import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { PushNotificationService } from "../../../data/services/push-notification.service";
import { Subscription } from "rxjs";
import { NotificationMessage } from "../../../data/models/interfaces/notification-message.interface";

@Component({
  selector: 'app-push-notification',
  templateUrl: './push-notification.component.html',
  styleUrls: ['./push-notification.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PushNotificationComponent implements OnInit, OnDestroy {

  showPanel: boolean = false;
  notification?: NotificationMessage;
  notificationSub: Subscription = new Subscription();
  notificationTimeout: any;

  constructor(
    private notificationService: PushNotificationService
  ) { }

  ngOnInit(): void {
    this.notificationService.getNotification()
      .subscribe(n => {
        if (n) {
          this.notification = n;
          this.showPanel = true;
          this.notificationTimeout = setTimeout(() => {
            this.showPanel = false;
          }, 3000);
        }
      });
  }

  dismissNotification() {
    this.showPanel = false;
  }

  ngOnDestroy() {
    this.notificationSub.unsubscribe();
    clearTimeout(this.notificationTimeout);
  }

}
